import axios from "axios";

export default {
    /**
     * Obtener solicitudes para el dashboard de autorizaciones
     */
    async obtenerSolicitudes(filtros = {}) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/autorizaciones/solicitudes",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(filtros),
        };

        try {
            const response = await axios(config);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            console.error('[AutorizacionesRepository] Error al obtener solicitudes:', error);
            throw error;
        }
    },

    /**
     * Registrar autorización individual (uno a uno)
     */
    async registrarAutorizacion(datos) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/autorizaciones/registrar",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                id_solicitud: datos.id_solicitud,
                tipo_autorizacion: datos.tipo_autorizacion, // 'finalizada' o 'retirada'
                observaciones: datos.observaciones || null
            }),
        };

        try {
            const response = await axios(config);
            if (response.status === 200) {
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            console.error('[AutorizacionesRepository] Error al registrar autorización:', error);
            throw error;
        }
    },

    /**
     * Carga masiva de autorizaciones (envía JSON parseado, no archivo)
     */
    async cargaMasivaAutorizaciones(datos) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/autorizaciones/carga-masiva",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify(datos),
        };

        try {
            const response = await axios(config);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            console.error('[AutorizacionesRepository] Error en carga masiva:', error);
            throw error;
        }
    },

    /**
     * Obtener historial de autorizaciones de una solicitud
     */
    async obtenerHistorial(idSolicitud) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/autorizaciones/historial",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                id_solicitud: idSolicitud
            }),
        };

        try {
            const response = await axios(config);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            console.error('[AutorizacionesRepository] Error al obtener historial:', error);
            throw error;
        }
    },

    /**
     * Obtener solicitudes SIN autorización (para filtro)
     */
    async obtenerSolicitudesSinAutorizacion() {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/autorizaciones/sin-autorizacion",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({}),
        };

        try {
            const response = await axios(config);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            console.error('[AutorizacionesRepository] Error al obtener solicitudes sin autorización:', error);
            throw error;
        }
    },

    /**
     * Descargar plantilla de Excel para carga masiva
     */
    descargarPlantilla(tipoAutorizacion) {
        // Crear archivo CSV en memoria
        let contenido = '';
        let nombreArchivo = '';

        if (tipoAutorizacion === 'finalizada') {
            contenido = 'id_solicitud,observaciones\n301,Autorización finalizada - Aprobado\n302,Solicitud completada satisfactoriamente\n303,';
            nombreArchivo = 'PLANTILLA_AUTORIZACIONES_FINALIZADAS.csv';
        } else if (tipoAutorizacion === 'retirada') {
            contenido = 'id_solicitud,observaciones\n301,Retiro de autorización por cambio en condiciones\n302,Retiro solicitado por el cliente\n303,';
            nombreArchivo = 'PLANTILLA_RETIRO_AUTORIZACIONES.csv';
        } else {
            console.error('Tipo de autorización no válido');
            return;
        }

        // Crear blob y descargar
        const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        link.setAttribute('href', url);
        link.setAttribute('download', nombreArchivo);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
